import React, { useState } from 'react';
import logo from './assets/logo.png';
import config from './config';
 

export function Logo ({redirectHome}){
  const [linkToHome, setLinkToHome] = useState(redirectHome === true)

  return (<>
    {linkToHome ? (<a href={config.appUrl}><img src={logo} alt="Logo" /></a>) : (<img src={logo} alt="Logo" />)}
    </>
  );
};



